import getSubscriptionsList from "../../graphql/queries/getSubscriptionsList";
import { subscriptionToLicence, perpetualToLicense } from "./mappers";
import { getLicenses } from "./queries";
import * as PerpetualFragment from "../../graphql/fragments/perpetual";
import * as gqlIds from "../../graphql/data-id";
import { subscriptionFromCache } from "./helpers";
import getPerpetuals from "../../graphql/queries/getPerpetuals";

const subscriptionsFromCache = cache =>
	cache.readQuery({ query: getSubscriptionsList })?.getSubscriptions;

const perpetualsFromCache = cache => cache.readQuery({ query: getPerpetuals })?.getPerpetuals;

const getLicensesFromCache = cache => {
	const subscriptions = subscriptionsFromCache(cache) || [];
	const perpetuals = perpetualsFromCache(cache) || [];

	return {
		__typename: "LicenseSet",
		subscriptions: subscriptions.map(subscriptionToLicence()), //
		perpetuals: perpetuals.map(perpetualToLicense),
	};
};

export const licenses = (parent, args, { cache }) => {
	const list = getLicensesFromCache(cache);
	cache.writeQuery({
		query: getLicenses,
		data: { licenses: list },
	});

	return list;
};

const perpetualFromCache = (cache, id) => {
	const perpetual = cache.readFragment({
		id,
		fragment: PerpetualFragment.allFields,
	});

	return perpetual && perpetualToLicense(perpetual);
};

const subscriptionLicenseFromCache = (cache, id) => {
	const subscription = subscriptionFromCache(cache, id);

	return subscription && subscriptionToLicence()(subscription);
};

export const license = (parent, { id }, { cache }) => {
	const isSubscription = Boolean(gqlIds.subscriptionId.parse(id));
	const isPerpetual = Boolean(gqlIds.perpetualId.parse(id));

	return (
		(isSubscription && subscriptionLicenseFromCache(cache, id)) ||
		(isPerpetual && perpetualFromCache(cache, id)) ||
		null
	);
};
